export async function fetchConfig(setConfig, setConfigLoaded) {
    try {
      const response = await fetch("/config.json");
      const configuration = await response.json();
      setConfig(configuration["API_URL"]);
      if (setConfigLoaded) {
        setConfigLoaded(true);
      }
    } catch (error) {
      console.error("Error de configuración:", error);
    }
  }
  